// Правила выбора формы для $tc в языках, где форм три, а не две.
//
// vue-i18n 8 по умолчанию умеет только «один | много» (для двух форм) или
// «ноль | один | много» (для трёх). Русскому, польскому, сербскому, хорватскому
// и румынскому
// нужны три формы вида «1 | 2–4 | 5+», поэтому для них правило своё. Строки в
// локалях для этих языков пишутся строго в порядке «один | несколько | много»:
//   ru: "сутки | суток | суток", pl: "dzień | dni | dni", ro: "zi | zile | de zile".
//
// Каждое правило получает число и количество форм в строке. Если строка
// двухформная (например, ключ не переведён и vue-i18n взял английский
// fallback), правило откатывается к «один | много», чтобы не выбрать
// несуществующий индекс и не вернуть строку целиком с разделителями.

function oneMany(n) {
  return n === 1 ? 0 : 1;
}

// ru, sr, hr: 1, 21, 31 → «один»; 2–4, 22–24 → «несколько»; остальное (в т.ч. 11–14) → «много».
function eastSlavic(choice, choicesLength) {
  const n = Math.abs(choice);
  if (choicesLength < 3) return oneMany(n);
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return 0;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 1;
  return 2;
}

// pl: «один» — только ровно 1 (21 dni, а не 21 dzień); 2–4, 22–24 → «несколько».
function polish(choice, choicesLength) {
  const n = Math.abs(choice);
  if (choicesLength < 3) return oneMany(n);
  if (n === 1) return 0;
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 1;
  return 2;
}

// ro: 1 → «один»; 0 и 2–19 (и 101–119…) → «несколько»; от 20 → «много» (с частицей «de»).
function romanian(choice, choicesLength) {
  const n = Math.abs(choice);
  if (choicesLength < 3) return oneMany(n);
  if (n === 1) return 0;
  const mod100 = n % 100;
  if (n === 0 || (mod100 >= 1 && mod100 <= 19)) return 1;
  return 2;
}

export const pluralizationRules = {
  ru: eastSlavic,
  sr: eastSlavic,
  hr: eastSlavic, // хорватский делит формы так же, как сербский
  pl: polish,
  ro: romanian,
};

export default pluralizationRules;

// Верхняя граница тарифного периода вида "13 - 24" (Company#periods,
// hourly_periods и т.п.) — по ней выбирается форма слова в заголовке таблицы
// цен: "1 - 1 час", "2 - 5 часов". Берётся последнее число в строке, поэтому
// одиночное "24" тоже работает; без чисел → 0 (форма «много»).
export function periodUpperBound(period) {
  const numbers = String(period == null ? "" : period).match(/\d+/g);
  return numbers ? Number(numbers[numbers.length - 1]) : 0;
}
